import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Student, StudentHistory } from './student.model';

@Injectable()
export class StudentService {
    resourceUrl = '/api/students';

    constructor(private http: HttpClient) {}

    findAll(): Observable<Student[]> {
        return this.http.get<Student[]>(this.resourceUrl);
    }

    findById(id): Observable<Student> {
        return this.http.get<Student>(this.resourceUrl + '/' + id);
    }

    findByCompanyId(id: number): Observable<Student[]> {
        return this.http.get<Student[]>('/api/companies/' + id + '/student');
    }

    update(student): Observable<Student[]> {
        return this.http.put<Student[]>(this.resourceUrl, student);
    }

    create(student) {
        return this.http.post(this.resourceUrl, student);
    }

    findBySearch(search: string): Observable<Student[]> {
        return this.http.get<Student[]>(this.resourceUrl + '/search/' + search);
    }

    historyById(id: number): Observable<StudentHistory> {
        return this.http.get<StudentHistory>(
            `${this.resourceUrl}/${id}/history`
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/directory/student/student.service.ts